<template>
    <div class="row">
        <div class="col-12">
            <h2>
                <b v-html="task.question" />
            </h2>
            <div>
                <ul class="list-unstyled">
                    <li v-for="(answer, index) in task.taskable.answers">
                        <label :for="`answer${index}`" style="cursor: pointer;">
                            <input
                                :type="task.taskable.is_multiple_choice ? 'checkbox' : 'radio'"
                                v-model="form.answers"
                                name="answer"
                                :id="`answer${index}`"
                                :value="answer.answer"
                                class="checkbox-2x"
                            >
                            {{ answer.answer }}
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        currentTask: {
            type: Number,
            required: true,
        },
        task: {
            type: Object,
            required: true,
        },
        value: Object,
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.$emit('input', this.form)
            }
        }
    },
    data() {
        return {
            form: {
                task_id: this.task.id,
                answers: [],
            }
        };
    },
    mounted() {
        this.$emit('input', this.form);
    }
}
</script>
